import {
  addDays,
  addMonths,
  endOfDay,
  endOfMonth,
  endOfWeek,
  startOfDay,
  startOfMonth,
  startOfWeek,
} from "date-fns";
import moment from "moment";
import uniqid from "uniqid";
import { TOOLTIP_POSITIONS_OPTIONS, WIDGET_POSITIONS_OPTIONS } from "./Enum";

export const DefinedCustomDates = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),

  today: {
    startDate: startOfDay(new Date()),
    endDate: endOfDay(new Date()),
  },
  yesterday: {
    startDate: startOfDay(addDays(new Date(), -1)),
    endDate: endOfDay(addDays(new Date(), -1)),
  },
  last7Days: {
    startDate: addDays(new Date(Date.now()), -7),
    endDate: endOfDay(addDays(new Date(), -1)),
  },
  last30Days: {
    startDate: addDays(new Date(Date.now()), -30),
    endDate: endOfDay(addDays(new Date(), -1)),
  },
  last90Days: {
    startDate: addDays(new Date(Date.now()), -90),
    endDate: endOfDay(addDays(new Date(), -1)),
  },
};

export const DateRangeOptions = [
  {
    id: uniqid(),
    name: "Today",
    value: "today",
    description: null,
    range: {
      startDate: DefinedCustomDates.startOfToday,
      endDate: DefinedCustomDates.endOfToday,

    },
  },
  {
    id: uniqid(),
    name: "Yesterday",
    value: "yesterday",
    description: null,
    range: {
      startDate: DefinedCustomDates.startOfYesterday,
      endDate: DefinedCustomDates.endOfYesterday,

    },
  },
  {
    id: uniqid(),
    name: "Last 7 Days",
    value: "7",
    description: null,
    range: {
      startDate: addDays(new Date(Date.now()), -7),
      endDate: DefinedCustomDates.endOfYesterday,

    },
  },
  {
    id: uniqid(),
    name: "Last 30 Days",
    value: "30",
    description: null,
    range: {
      startDate: addDays(new Date(Date.now()), -30),
      endDate: DefinedCustomDates.endOfYesterday,

    },
  },
  {
    id: uniqid(),
    name: "Last 90 Days",
    value: "90",
    description: null,
    range: {
      startDate: addDays(new Date(Date.now()), -90),
      endDate: DefinedCustomDates.endOfYesterday,

    },
  },
];

export const DefaultIndiaMobileFormat = {
  countryCode: "91",
  dialCode: "91",
  format: "+.. .....-.....",
  iso2: "in",
  name: "India",
  priority: 0,
  regions: ["asia"],
};

export const notSupportedHexCodes = ['#ffffff']

export const topUserMenuOptions = [
  {
    id: uniqid(),
    name: "Plans",
    avatar: "ri-copper-diamond-line",
    url: "/plans",
    isAgentRoute: false,
  },
  {
    name: "Logout",
    avatar: "ri-logout-circle-r-line",
    url: "/login",
    isAgentRoute: true,
  },
];

export const LeftTopMenuOptions = [
  {
    avatar: "ri-bar-chart-line",
    name: "Analytics",
    id: uniqid(),
    url: "/bot/{0}/analytics",
    isAvailable: true,
    agentRoute: true,
  },
  {
    avatar: "ri-question-answer-line",
    name: "Chat History",
    id: uniqid(),
    url: "/bot/{0}/chathistory/bot-chats",
    isAvailable: true,
    agentRoute: true,
  },
  // {
  //   avatar: "ri-chat-smile-3-line",
  //   name: "My Bots",
  //   id: uniqid(),
  //   url: "/bot",
  //   isAvailable: true,
  //   agentRoute: true,
  // },
  {
    avatar: "ri-building-3-line",
    name: "Bot Builder",
    id: uniqid(),
    url: "workspace/{0}/setup/bots",
    isAvailable: true,
  },
  {
    avatar: "ri-group-line",
    name: "Contacts",
    id: uniqid(),
    url: "/bot/{0}/leads",
    isAvailable: true,
    agentRoute: true,
  },
  {
    avatar: "ri-plug-line",
    name: "Integrations",
    id: uniqid(),
    url: "/bot/{0}/integrations/zoho",
    isAvailable: true,
  },
];

export const LeftBottomMenuOptions = [
  {
    avatar: "ri-settings-2-line",
    name: "Settings",
    id: uniqid(),
    url: "/bot/{0}/settings/look-feel",
    isAvailable: false,
  },
];

export const botTypeOptions = [
  {
    id: 1,
    name: "Lead Generation",
    description: null,
  },
  {
    id: 2,
    name: "Admissions",
    description: null,
  },
  {
    id: 3,
    name: "General Enquiry",
    description: null,
  },
  {
    id: 4,
    name: "Appointment Booking",
    description: null,
  },
];

export const NotificationBlockIconOptions = [
  {
    id: 1,
    name: "Alert",
    description: null,
  },
  {
    id: 2,
    name: "Ticket",
    description: null,
  },
  {
    id: 3,
    name: "Broadcast",
    description: null,
  },
  {
    id: 4,
    name: "Bell",
    description: null,
  },
];

export const botCategoriesOption = [
  {
    id: 1,
    name: "Travel Booking",
    description: null,
  },
  {
    id: 2,
    name: "Discount & Offers",
    description: null,
  },
  {
    id: 3,
    name: "Health Appointment",
    description: null,
  },
  {
    id: 4,
    name: "Education",
    description: null,
  },
];

export const ChatVisibilityOptions = [
  {
    id: 1,
    name: "Mobiles",
    description: null,
  },
  {
    id: 2,
    name: "Tablets",
    description: null,
  },
  {
    id: 3,
    name: "Desktop",
    description: null,
  },
  {
    id: 4,
    name: "All",
    description: null,
  },
];

export const SoundVisibilityOptions = [
  {
    id: 1,
    name: "Mobiles",
    description: null,
  },
  {
    id: 2,
    name: "Tablets",
    description: null,
  },
  {
    id: 3,
    name: "Desktop",
    description: null,
  },
  {
    id: 4,
    name: "All",
    description: null,
  },
];

export const LanguageOptions = [
  {
    id: uniqid(),
    name: "English",
    value: "english",
    description: null,
    enabled: true,
  },
  {
    id: uniqid(),
    name: "Hindi",
    value: "hindi",
    description: null,
    enabled: true,
  },
  {
    id: uniqid(),
    name: "Marathi",
    value: "marathi",
    description: null,
    enabled: true,
  },
  {
    id: uniqid(),
    name: "Gujrati",
    value: "gujrati",
    description: null,
    enabled: true,
  },
  {
    id: uniqid(),
    name: "Punjabi",
    value: "punjabi",
    description: null,
    enabled: true,
  },
];

export const FontOptions = [
  {
    id: uniqid(),
    name: "Poppins",
    value: "Poppins",
    description: null,
  },
  {
    id: uniqid(),
    name: "Roboto",
    value: "Roboto",
    description: null,
  },
  {
    id: uniqid(),
    name: "Open Sans",
    value: "Open Sans",
    description: null,
  },
  {
    id: uniqid(),
    name: "Inter",
    value: "Inter",
    description: null,
  },
];
export const RetryOptions = [
  {
    id: uniqid(),
    name: "1",
    value: "1",
    description: null,
  },
  {
    id: uniqid(),
    name: "2",
    value: "2",
    description: null,
  },
  {
    id: uniqid(),
    name: "3",
    value: "3",
    description: null,
  },
  {
    id: uniqid(),
    name: "4",
    value: "4",
    description: null,
  },
  {
    id: uniqid(),
    name: "5",
    value: "5",
    description: null,
  },
];

export const FontSizeOptions = [
  {
    id: uniqid(),
    name: "11px",
    value: "11",
    description: null,
  },
  {
    id: uniqid(),
    name: "12px",
    value: "12",
    description: null,
  },
  {
    id: uniqid(),
    name: "13px",
    value: "13",
    description: null,
  },
  {
    id: uniqid(),
    name: "14px",
    value: "14",
    description: null,
  },
  {
    id: uniqid(),
    name: "15px",
    value: "15",
    description: null,
  },
  {
    id: uniqid(),
    name: "16px",
    value: "16",
    description: null,
  },
  {
    id: uniqid(),
    name: "17px",
    value: "17",
    description: null,
  },
  {
    id: uniqid(),
    name: "18px",
    value: "18",
    description: null,
  },
  {
    id: uniqid(),
    name: "19px",
    value: "19",
    description: null,
  },
  {
    id: uniqid(),
    name: "20px",
    value: "20",
    description: null,
  },
];

export const widgetPositionOptions = [
  WIDGET_POSITIONS_OPTIONS.LEFT,
  WIDGET_POSITIONS_OPTIONS.RIGHT,
];

export const popupPositionOptions = [
  TOOLTIP_POSITIONS_OPTIONS.SIDE,
  TOOLTIP_POSITIONS_OPTIONS.TOP,
];
export const QuickMenuViewOptions = [
  "Lists",
  "Blocks",
];
export const QuickMenuLinkOptions = [
  "Add Link",
  "Link To Flow",
];
export const QuickBannerLinkOptions = [
  "Image",
  "Video",
];


export const RoutingMethodOptions = [
  {
    id: "Assigned",
    value: "Assigned",
    name: "Assigned",
    caption:
      "Chats help maintain an even workload distribution, especially for larger teams.",
  },
  {
    id: "Pooled",
    value: "Pooled",
    name: "Pooled",
    caption:
      "Chats will not be assigned to agents automatically, instead they will have to manually get chats from the not assigned ones.",
  },
];
export const BotTypeOptions = [
  {
    id: uniqid(),
    value: 1,
    name: "Answers",
    caption:
      "Train your bot to answer different kinds of questions so that it can figure out what the customer wants and send them to",
    icon: "ri-question-answer-line",
  },
  {
    id: uniqid(),
    value: 2,
    name: "Flow Based",
    caption:
      "Build fully functional flow based conversational bot using visual builder.",
    icon: "ri-question-answer-line",
  },
];

export const LeadsTableDefaultColumns = [];

export const EmailFrequencyOptions = ["Hourly", "Daily", "Weekly"];

export const CustomizeMenuOptions = [
  {
    category: "Appearance",
    isAvailable: true,
    options: [
      {
        title: "Look & Feel",
        url: "/bot/{0}/setup/customize/look-feel",
        isAvailable: true,
        id: uniqid(),
        icon: "ri-palette-line",
      },
      {
        title: "Callout",
        url: "/bot/{0}/setup/customize/popout-message",
        isAvailable: true,
        id: uniqid(),
        // icon: "ri-record-mail-line",
        icon: "ri-broadcast-line",
      },
      {
        title: "Notification Preferences",
        url: "/bot/{0}/setup/customize/notifications",
        isAvailable: true,
        id: uniqid(),
        icon: "ri-volume-down-line",
      },
      // {
      //   title: "Unbranding",
      //   url: "/bot/{0}/setup/customize/unbranding",
      //   isAvailable: false,
      //   id: uniqid(),
      //   icon: "ri-flashlight-line",
      // },
    ],
  },

  {
    category: "Conversation",
    isAvailable: true,
    options: [
      {
        title: "Notification block",
        url: "/bot/{0}/setup/customize/notification-block",
        isAvailable: true,
        id: uniqid(),
      },
      {
        title: "Quick Menu",
        url: "/bot/{0}/setup/customize/quick-menu",
        isAvailable: true,
        id: uniqid(),
        // icon: "ri-palette-line",
      },
      {
        title: "Banner",
        url: "/bot/{0}/setup/customize/banner",
        isAvailable: true,
        id: uniqid(),
        // icon: "ri-palette-line",
      },

      {
        title: "labels",
        url: "/bot/{0}/setup/customize/notification-labels",
        isAvailable: false,
        id: uniqid(),
        // icon: "ri-palette-line",
      },


    ],
  },
];

export const ConfigureMenuOptions = [
  {
    category: "Conversation",
    isAvailable: true,
    options: [
      {
        title: "Enabled Devices",
        url: "/bot/{0}/setup/configure/enabled-devices",
        isAvailable: true,
        id: uniqid(),
      },
      {
        title: "Blacklist Urls",
        url: "/bot/{0}/setup/configure/blacklist-urls",
        isAvailable: true,
        id: uniqid(),
      },

      {
        title: "Auto Replies",
        url: "/bot/{0}/setup/configure/auto-replies",
        isAvailable: true,
        id: uniqid(),
      },
    ],
  },

  {
    category: "Live Chat",
    isAvailable: false,
    options: [
      {
        title: "Agents",
        url: "/bot/{0}/setup/configure/agents",
        isAvailable: true,
        id: uniqid(),
      },
      {
        title: "Departments",
        url: "/bot/{0}/setup/configure/departments",
        isAvailable: true,
        id: uniqid(),
      },
      {
        title: "Teams",
        url: "/bot/{0}/setup/configure/teams",
        isAvailable: false,
        id: uniqid(),
      },
      {
        title: "Business Hours",
        url: "/bot/{0}/setup/configure/active-timings",
        isAvailable: true,
        id: uniqid(),
      },
    ],
  },
  {
    category: "Alerts & Notifications",
    isAvailable: false,
    options: [
      {
        title: "Email Notifications",
        url: "/bot/{0}/setup/configure/email-notifications",
        isAvailable: false,
        id: uniqid(),
      },
      {
        title: "Sms Notification",
        url: "/bot/{0}/setup/configure/sms-notifications",
        isAvailable: false,
        id: uniqid(),
      },
      {
        title: "Push Notifications",
        url: "/bot/{0}/setup/configure/push-notifications",
        isAvailable: false,
        id: uniqid(),
      },
    ],
  },
];

export const DeployMenuOptions = [
  {
    category: "Deploy Scripts",
    isAvailable: true,
    options: [
      {
        title: "Website",
        url: "/bot/{0}/setup/deploy/website",
        isAvailable: true,
        id: uniqid(),
      },
      {
        title: "Whatsapp",
        url: "/bot/{0}/setup/deploy/website",
        isAvailable: false,
        id: uniqid(),
      },
    ],
  },
];

export const BotBuilderTabsOptions = [
  {
    name: "Customize",
    id: uniqid(),
    url: "/bot/{0}/setup/customize/look-feel",
    isAvailable: true,
    value: "setup/customize",
  },
  {
    name: "Flow Builder",
    id: uniqid(),
    url: "/bot/{0}/setup/flow",
    isAvailable: true,
    value: "setup/flow",
  },
  {
    name: "FAQ Builder",
    id: uniqid(),
    url: "/bot/{0}/setup/faq",
    isAvailable: true,
    value: "setup/faq",
  },
  // {
  //   name: "Chat Languages",
  //   id: uniqid(),
  //   url: "/bot/{0}/setup/languages",
  //   isAvailable: true,
  //   value: "setup/languages",
  // },
  {
    name: "Settings",
    id: uniqid(),
    url: "/bot/{0}/setup/configure/enabled-devices",
    isAvailable: true,
    value: "setup/configure",
  },
  {
    name: "Deploy",
    id: uniqid(),
    url: "/bot/{0}/setup/deploy/website",
    isAvailable: true,
    value: "setup/deploy",
  },
];

export const IntegrationMenuOptions = [
  {
    category: "Other Integrations",
    isAvailable: true,
    options: [
      {
        title: "Zoho",
        url: "/bot/{0}/integrations/zoho",
        id: uniqid(),
        isAvailable: true,
        brandLogo: "https://www.zoho.com/branding/images/zoho-logo.png",
      },

      {
        title: "Google Sheets",
        url: "/bot/{0}/integrations/google-sheets",
        id: uniqid(),
        isAvailable: true,
        brandLogo:
          "https://upload.wikimedia.org/wikipedia/commons/3/30/Google_Sheets_logo_%282014-2020%29.svg",
      },
      {
        title: "Shopify",
        url: "/bot/{0}/integrations/shopify",
        id: uniqid(),
        isAvailable: false,
        brandLogo:
          "https://cdn.shopify.com/shopifycloud/brochure/assets/brand-assets/shopify-logo-shopping-bag-full-color-66166b2e55d67988b56b4bd28b63c271e2b9713358cb723070a92bde17ad7d63.svg",
      },
    ],
  },
  {
    category: "Channels Integrations",
    isAvailable: false,
    options: [
      {
        title: "Facebook",
        url: "/bot/{0}/integrations/facebook",
        id: uniqid(),
        isAvailable: true,
        brandLogo:
          "https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
      },
      {
        title: "Instagram",
        url: "/bot/{0}/integrations/instagram",
        id: uniqid(),
        isAvailable: true,
        brandLogo:
          "https://upload.wikimedia.org/wikipedia/commons/e/e7/Instagram_logo_2016.svg",
      },
      {
        title: "Whatsapp",
        url: "/bot/{0}/integrations/whatsapp",
        id: uniqid(),
        isAvailable: false,
        brandLogo:
          "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
      },
      {
        title: "Sms",
        url: "/bot/{0}/integrations/sms",
        id: uniqid(),
        isAvailable: false,
        brandLogo:
          "https://upload.wikimedia.org/wikipedia/commons/7/72/Message-icon-grey.png",
      },
    ],
  },
];

export const ChatHistorySidebarOptions = [
  {
    category: "Conversations",
    isAvailable: true,
    options: [
      {
        title: "Bot Chats",
        url: "/bot/{0}/chathistory/bot-chats",
        isAvailable: true,
        id: uniqid(),
        icon: "ri-inbox-line",
      },
      {
        icon: "ri-message-2-line",
        title: "Live Chat",
        id: uniqid(),
        url: "/bot/{0}/chathistory/live-chat",
        isAvailable: false,
      },
      {
        title: "Unassigned",
        url: "/bot/{0}/chathistory/unassigned",
        isAvailable: false,
        id: uniqid(),
        icon: "ri-inbox-line",
      },
      {
        title: "You",
        url: "/bot/{0}/chathistory/you",
        isAvailable: false,
        id: uniqid(),
        icon: "ri-user-line",
      },
      {
        title: "Team",
        url: "/bot/{0}/chathistory/team",
        isAvailable: false,
        id: uniqid(),
        icon: "ri-team-line",
      },

      {
        title: "Resolved",
        url: "/bot/{0}/chathistory/resolved",
        isAvailable: false,
        id: uniqid(),
        icon: "ri-archive-line",
      },
      {
        title: "All",
        url: "/bot/{0}/chathistory/all",
        isAvailable: false,
        id: uniqid(),
        icon: "ri-filter-3-line",
      },
    ],
  },
  {
    category: "Channels",
    isAvailable: false,
    options: [
      {
        title: "All",
        url: "/bot/{0}/chathistory/channels",
        isAvailable: false,
        id: uniqid(),
        icon: "ri-message-3-line",
      },
      {
        title: "Facebook",
        url: "/bot/{0}/chathistory/facebook",
        isAvailable: false,
        id: uniqid(),
        icon: "ri-messenger-fill",
      },
      {
        title: "Instagram",
        url: "/bot/{0}/chathistory/instagram",
        isAvailable: false,
        id: uniqid(),
        icon: "ri-instagram-line",
      },
      {
        title: "Whatsapp",
        url: "/bot/{0}/chathistory/whatsapp",
        isAvailable: false,
        id: uniqid(),
        icon: "ri-whatsapp-line",
      },
    ],
  },
];

export const SampleTableUrls = [
  // {
  //   title: "About us",
  //   url: "www.google.com/about-us",
  //   short_code: "help",
  //   response: "Hi, How can i help you?",
  //   language:'English',
  //   visitors:12332,
  // },
];

export const xLabelsHeatMap: string[] = [
  "0 AM",
  "1 AM",
  "2 AM",
  "3 AM",
  "4 AM",
  "5 AM",
  "6 AM",
  "7 AM",
  "8 AM",
  "9 AM",
  "10 AM",
  "11 AM",
  "12 PM",
  "1 PM",
  "2 PM",
  "3 PM",
  "4 PM",
  "5 PM",
  "6 PM",
  "7 PM",
  "8 PM",
  "9 PM",
  "10 PM",
  "11 PM",
];

export const yLabelsHeatMap: string[] = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
];

export const daySorterHeatMap: any = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 7,
};

export const SampleTableData = [
  {
    id: uniqid(),
    agent_name: "Anmol Tanwar",
    role: { name: "Super Admin", value: 1 },
    online: true,
    avatar: {
      id: 13,
      source:
        "https://cdn.pixabay.com/photo/2020/11/22/22/17/male-5768177_960_720.png",
    },
    phone: 919992610,
    email: "anmol.tanwar@srvmedia.com",
    department: { name: "Management", value: 2 },
    concurrent_chat: 15,
    verified: true,
    last_login: moment(),
  },
  {
    id: uniqid(),
    agent_name: "Abc Singh",
    role: { name: "Admin", value: 1 },
    online: false,
    avatar: { id: 15, source: "" },
    phone: 911232610022,
    email: "tanwaranmol@gmail.com",
    department: { name: "Admin", value: 1 },
    concurrent_chat: 9,
    verified: false,
    last_login: moment(),
    selected: true,
  },
];
export const SampleDepartmentsTableData = [
  {
    department_name: "Sales",
    agent: [
      {
        agent_name: "Anmol",
      },
      {
        agent_name: "Singh",
      },
    ],
    description: "nothing",
    routing: "Assigned",
    status: true,
  },
  {
    department_name: "Admin",
    agent: SampleTableData,
    description: "kuch bhi nhi",
    routing: "Pooled",
    status: false,
  },
  {
    department_name: "Pr",
    agent: SampleTableData,
    description: "Lorem ipsum dolor sit amet,",
    routing: "Assigned",
    status: true,
  },
];

export const RoleOptions = [
  {
    id: uniqid(),
    name: "Admin",
    value: 1,
    description: null,
  },
  {
    id: uniqid(),
    name: "Agent",
    value: 2,
    description: null,
  },
];
export const DepartmentOptions = [
  {
    id: uniqid(),
    name: "All",
    value: 3,
    description: null,
  },
  {
    id: uniqid(),
    name: "Management",
    value: 1,
    description: null,
  },
  {
    id: uniqid(),
    name: "Sales",
    value: 2,
    description: null,
  },
];
